// extracted by mini-css-extract-plugin
export default {"content":"Items_content__zXDdh"};